var map = {
	"./Body Jab Corss 1.fbx": "0a0e",
	"./Body Jab Corss 2.fbx": "b360",
	"./Body Jab Corss 3.fbx": "1402",
	"./Boxing (1).fbx": "ce8e",
	"./Boxing 1.fbx": "f429",
	"./Boxing 10.fbx": "0de0",
	"./Boxing 2.fbx": "e384",
	"./Boxing 3.fbx": "c600",
	"./Boxing 4.fbx": "1a90",
	"./Boxing 5.fbx": "e23b",
	"./Boxing 6.fbx": "dd64",
	"./Boxing 7.fbx": "abe4",
	"./Boxing 8.fbx": "e040",
	"./Boxing 9.fbx": "ffbf",
	"./Boxing.fbx": "e560",
	"./Combo Punch.fbx": "91b4",
	"./Dodging (1).fbx": "33de",
	"./Dodging (2).fbx": "c4c3",
	"./Dodging.fbx": "72ca",
	"./Elbow Punch.fbx": "ac72",
	"./Entry (1).fbx": "7d2c",
	"./Entry (2).fbx": "8fe3",
	"./Entry.fbx": "84a8",
	"./Fighting Idle.fbx": "a2e6",
	"./Headbutt (1).fbx": "6502",
	"./Headbutt.fbx": "bb0e",
	"./Hook 1.fbx": "b1ce",
	"./Hook 2.fbx": "f9b3",
	"./Hook 3.fbx": "8e73",
	"./Hook 4.fbx": "b39e",
	"./Hook 5.fbx": "b8f4",
	"./Hook 6.fbx": "6ea7",
	"./Illegal Elbow Punch (1).fbx": "4050",
	"./Illegal Elbow Punch (2).fbx": "071e",
	"./Illegal Elbow Punch.fbx": "84f3",
	"./Illegal Headbutt.fbx": "1185f",
	"./Jab Cross (1).fbx": "e188",
	"./Jab Cross (2).fbx": "d8c7",
	"./Jab Cross.fbx": "6617",
	"./Lead Jab (1).fbx": "8f64",
	"./Lead Jab (2).fbx": "fbc0",
	"./Lead Jab (3).fbx": "f803",
	"./Lead Jab (4).fbx": "73eb",
	"./Lead Jab (5).fbx": "a57e",
	"./Lead Jab.fbx": "f259",
	"./Left Pivot (1).fbx": "e5de",
	"./Left Pivot.fbx": "c8e8",
	"./Livershot Knockdown.fbx": "e1a7",
	"./Long Left Side Step.fbx": "5b14",
	"./Long Right Side Step.fbx": "363a",
	"./Long Step Forward.fbx": "f49b",
	"./Medium Left Side Step.fbx": "5702",
	"./Medium Right Side Step.fbx": "5ab3",
	"./Medium Step Forward.fbx": "b559",
	"./Punch Combo.fbx": "cf2c",
	"./Punching (1).fbx": "db4e",
	"./Punching (2).fbx": "625f",
	"./Punching (3).fbx": "74d3",
	"./Punching (4).fbx": "424e",
	"./Punching.fbx": "800e",
	"./Right Hook.fbx": "e1ad",
	"./Right Pivot (1).fbx": "68b6",
	"./Right Pivot.fbx": "ecdd",
	"./Short Left Side Step.fbx": "2b54",
	"./Short Right Side Step.fbx": "d09c",
	"./Short Step Forward.fbx": "a529",
	"./Speedbag.fbx": "0b03",
	"./Step Backward (1).fbx": "c7e2",
	"./Step Backward (2).fbx": "4bc9",
	"./Step Backward.fbx": "4019",
	"./Uppercut.fbx": "b5fb",
	"./Walking (2).fbx": "3b53",
	"./Walking Backwards.fbx": "d28e",
	"./Walking.fbx": "7460",
	"./Warming Up.fbx": "1e1ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0803";